import { render } from "./DRecord.vue?vue&type=template&id=31c4cac4&scoped=true"
import script from "./DRecord.vue?vue&type=script&lang=js"
export * from "./DRecord.vue?vue&type=script&lang=js"

import "./DRecord.vue?vue&type=style&index=0&id=31c4cac4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c4cac4"]])

export default __exports__